"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _selectedItemStatusEnum = _interopRequireDefault(require("./selectedItemStatusEnum"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var StatusColumn = function StatusColumn(_ref) {
  var status = _ref.status;
  return status === _selectedItemStatusEnum["default"].CAN_BE_ADDED ? '' : status;
};
var _default = StatusColumn;
exports["default"] = _default;